import { TFunction } from "i18next";
import { string } from "yup";

import { NAME_MAX_LENGTH } from "domain/globalConstants";

export interface ReportSignatureKey {
    name: string;
    fingerprint: string;
    created: string;
    creatorUuid: string;
    creatorEmail: string;
}

export interface ReportSignatureKeyResult {
    title: string;
    message: string;
}

export function createSignatureKeyNameSchema(t: TFunction, existingNames: string[], currentName?: string) {
    return string()
        .trim()
        .required(t("ReportSignatureKeys.addForm.name.required"))
        .max(NAME_MAX_LENGTH, t("ReportSignatureKeys.addForm.name.lengthException", { length: NAME_MAX_LENGTH }))
        .test("Name already exists", t("ReportSignatureKeys.addForm.name.alreadyExistsException"), (value) => {
            const trimmedValue = value?.trim();
            return trimmedValue == null || trimmedValue === currentName || !existingNames.includes(trimmedValue);
        });
}
